import { useEffect } from "react";
import { Button, FormActions } from "@atlas/ui/web";

/**
 * Confirmacao pra destravar os campos de dados oficiais (Receita/Junta
 * Comercial) nos cadastros de prefeitura e banco.
 *
 * Existe porque algumas consultas de CNPJ voltam incompletas (codigo IBGE
 * zerado, atividade principal vazia) e o operador ficava sem saida: os campos
 * sao readOnly e a validacao do modal os exige. O destravamento e' consciente —
 * o operador le o que esta abrindo mao antes de confirmar — e fica registrado
 * (flag `dadosEditadosManualmente` + auditoria na API).
 *
 * Sem props de conteudo: o texto e' identico nas duas telas.
 */
export function ConfirmarEdicaoManualModal({
  onConfirm,
  onClose,
}: {
  onConfirm: () => void;
  onClose: () => void;
}) {
  // Esc fecha — mesma convencao do ConfirmarRecusaModal/ConfirmDeleteModal.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }} style={modalBackdrop}>
      <div onMouseDown={(e) => e.stopPropagation()} style={modalCard}>
        <h3 style={{ margin: 0 }}>Habilitar edição manual</h3>

        <div style={{
          padding: 14, borderRadius: 10,
          background: "color-mix(in srgb, var(--gold-500) 8%, transparent)",
          border: "1px solid color-mix(in srgb, var(--gold-500) 30%, transparent)",
        }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--gold-500)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 8 }}>
            ⚠ Os dados oficiais poderão ser sobrescritos
          </div>
          <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
            Deseja habilitar a edição manual? Os dados oficiais da Receita/Junta Comercial
            poderão ser sobrescritos — razão social, nome fantasia, atividade principal, UF,
            código IBGE e endereço deixam de refletir exatamente a fonte oficial.
          </div>
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 8 }}>
            Use quando a consulta do CNPJ voltar incompleta. O cadastro fica marcado como
            editado manualmente e o destravamento é registrado na auditoria. Pesquisar o CNPJ
            novamente restaura os dados oficiais e volta a travar os campos.
          </div>
        </div>

        <FormActions>
          <Button variant="ghost" type="button" onClick={onClose}>Cancelar</Button>
          {/* Nao existe variante `warn` no Button — o padrao do repo e' ghost
              com as cores sobrescritas (ver ConfirmarRecusaModal.tsx). */}
          <Button
            variant="ghost"
            type="button"
            onClick={onConfirm}
            style={{ borderColor: "var(--gold-500)", color: "var(--gold-500)" }}
          >
            Habilitar edição
          </Button>
        </FormActions>
      </div>
    </div>
  );
}

// zIndex acima do modal de cadastro (que usa 100) — mesma escala do
// ConfirmarRecusaModal.
const modalBackdrop: React.CSSProperties = {
  position: "fixed", inset: 0, background: "rgba(10,22,40,.6)",
  display: "flex", alignItems: "flex-start", justifyContent: "center",
  padding: "24px 16px", overflowY: "auto",
  zIndex: 110, backdropFilter: "blur(6px)",
};
const modalCard: React.CSSProperties = {
  background: "var(--bg-elev)", border: "1px solid var(--border-strong)",
  borderRadius: 14, padding: 24, maxWidth: 520, width: "calc(100% - 32px)",
  maxHeight: "calc(100vh - 48px)", overflowY: "auto",
  display: "flex", flexDirection: "column", gap: 16, boxShadow: "var(--shadow-lg)",
  margin: "auto",
};
